/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief Javascript 파일 처리 함수
 *
 ********************************************************************/
import dayjs from "dayjs";
import * as XLSX from "xlsx";
export function saveToFile_Chrome(fileName, content) {
    var blob = new Blob([content], { type: "multipart/form-data" });
    var objURL = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.download = fileName;
    a.href = objURL;
    a.style.display = "none";
    // for new window
    a.target = "_blank";
    a.rel = "noreferrer";
    //
    document.body.appendChild(a); //
    a.click();
    a.remove(); //
    window.URL.revokeObjectURL(objURL);
}
export const ExcelSheet = XLSX.utils.aoa_to_sheet([
    ["no", "spgName", "panelName", "itemName", "serialNo", "manufacturer", "	madeyyyyMM", "memo"],
    [
        "설명",
        "설비유형",
        `판넬명(GIS, 유입식TR 입력금지)`,
        `형명(배전반 입력금지)`,
        `시리얼번호(배전반 미 입력 가능)`,
        "제조사",
        "제조년월",
        "메모",
        "SPG 별 ElecInfo1",
        "SPG 별 ElecInfo2",
        "SPG 별 ElecInfo3",
        "SPG 별 ElecInfo4",
        "SPG 별 ElecInfo5",
        "SPG 별 ElecInfo6",
        "SPG 별 ElecInfo7",
        "SPG 별 ElecInfo8",
        "SPG 별 ElecInfo9",
        "SPG 별 ElecInfo10",
        "SPG 별 ElecInfo11",
        "SPG 별 ElecInfo12",
        "SPG 별 ElecInfo13",
        "SPG 별 ElecInfo14",
        "SPG 별 ElecInfo15",
        "SPG 별 ElecInfo16",
        "SPG 별 ElecInfo17",
        "SPG 별 ElecInfo18",
        "SPG 별 ElecInfo19",
        "SPG 별 ElecInfo20",
        "SPG 별 ElecInfo21",
        "SPG 별 ElecInfo2",
        "SPG 별 ElecInfo23",
        "SPG 별 ElecInfo24",
        "SPG 별 ElecInfo25",
        "SPG 별 ElecInfo26",
        "SPG 별 ElecInfo27",
        "SPG 별 ElecInfo28",
        "SPG 별 ElecInfo29",
        "SPG 별 ElecInfo30",
    ],
]);
export const ExcelDataMapping = (excelData, excelSheet) => {
    excelData.map((sheet, idx) => {
        XLSX.utils.sheet_add_aoa(excelSheet, [
            [
                idx + 1,
                sheet.spgName,
                sheet.panelName,
                sheet.itemName,
                sheet.serialNo,
                sheet.manufacturer,
                sheet.madeyyyyMM ? dayjs(sheet.madeyyyyMM).format("YYYY-MM-DD") : " ",
                sheet.memo,
                sheet.elecInfo.values[0],
                sheet.elecInfo.values[1],
                sheet.elecInfo.values[2],
                sheet.elecInfo.values[3],
                sheet.elecInfo.values[4],
                sheet.elecInfo.values[5],
                sheet.elecInfo.values[6],
                sheet.elecInfo.values[7],
                sheet.elecInfo.values[8],
                sheet.elecInfo.values[9],
                sheet.elecInfo.values[10],
                sheet.elecInfo.values[11],
                sheet.elecInfo.values[12],
                sheet.elecInfo.values[13],
                sheet.elecInfo.values[14],
                sheet.elecInfo.values[15],
                sheet.elecInfo.values[16],
                sheet.elecInfo.values[17],
                sheet.elecInfo.values[18],
                sheet.elecInfo.values[19],
                sheet.elecInfo.values[20],
                sheet.elecInfo.values[21],
                sheet.elecInfo.values[22],
                sheet.elecInfo.values[23],
                sheet.elecInfo.values[24],
                sheet.elecInfo.values[25],
                sheet.elecInfo.values[26],
                sheet.elecInfo.values[27],
                sheet.elecInfo.values[28],
                sheet.elecInfo.values[29],
                sheet.elecInfo.values[30],
            ],
        ], { origin: -1 });
        excelSheet["!cols"] = [
            //< --행 사이즈
            { width: 8 },
            { width: 10 },
            { width: 20 },
            { width: 30 },
            { width: 30 },
            { width: 30 },
            { width: 30 }, // 메모
        ];
        return false;
    });
};
export const HighItemExcelHeaderRow = [
    "No",
    "분전소 명",
    "형명",
    "시리얼번호",
    "제조년월",
    "설비유형",
    "정격용량 (kVA)",
    "1차전압 (kV)",
    "2차전압 (kV)",
    "최저소비효율 (%)",
    "무부하손 (W)",
    "부하손 (W)",
    "표준소비효율 (%)",
    "고효율 무부하손 (W)",
    "고효율 부하손 (W)",
    "부하율 (%)",
    "연간 절감비용 (백만원)",
    "CO₂ 감축량 (tCO₂/yr)",
    "Payback Period (년)",
    "저장일시",
];
export const createHighItemExcelSheet = () => XLSX.utils.aoa_to_sheet([HighItemExcelHeaderRow]);
export const HighItemExcelDataMapping = (excelData, excelSheet) => {
    const rows = Array.isArray(excelData) ? excelData : excelData ? [excelData] : [];
    rows.map((sheet, idx) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const created = (sheet === null || sheet === void 0 ? void 0 : sheet.createdTime) ? dayjs(sheet.createdTime) : null;
        const createdText = created && created.isValid() ? created.format("YYYY-MM-DD HH:mm:ss") : " ";
        XLSX.utils.sheet_add_aoa(excelSheet, [
            [
                idx + 1,
                (_a = sheet === null || sheet === void 0 ? void 0 : sheet.roomName) !== null && _a !== void 0 ? _a : " ",
                (_b = sheet === null || sheet === void 0 ? void 0 : sheet.itemName) !== null && _b !== void 0 ? _b : " ",
                (_c = sheet === null || sheet === void 0 ? void 0 : sheet.serialNo) !== null && _c !== void 0 ? _c : " ",
                (_d = sheet === null || sheet === void 0 ? void 0 : sheet.madeyyyyMM) !== null && _d !== void 0 ? _d : " ",
                (_e = sheet === null || sheet === void 0 ? void 0 : sheet.spgName) !== null && _e !== void 0 ? _e : " ",
                (_f = sheet === null || sheet === void 0 ? void 0 : sheet.capacity) !== null && _f !== void 0 ? _f : " ",
                (_g = sheet === null || sheet === void 0 ? void 0 : sheet.premiumVoltage) !== null && _g !== void 0 ? _g : " ",
                (_h = sheet === null || sheet === void 0 ? void 0 : sheet.secondaryVoltage) !== null && _h !== void 0 ? _h : " ",
                (_j = sheet === null || sheet === void 0 ? void 0 : sheet.meps) !== null && _j !== void 0 ? _j : " ",
                (_k = sheet === null || sheet === void 0 ? void 0 : sheet.noLoadLoss) !== null && _k !== void 0 ? _k : " ",
                (_l = sheet === null || sheet === void 0 ? void 0 : sheet.loadLoss) !== null && _l !== void 0 ? _l : " ",
                (_m = sheet === null || sheet === void 0 ? void 0 : sheet.standardEfficiency) !== null && _m !== void 0 ? _m : " ",
                (_o = sheet === null || sheet === void 0 ? void 0 : sheet.highNoLoadLoss) !== null && _o !== void 0 ? _o : " ",
                (_p = sheet === null || sheet === void 0 ? void 0 : sheet.highLoadLoss) !== null && _p !== void 0 ? _p : " ",
                (_q = sheet === null || sheet === void 0 ? void 0 : sheet.loadPercentage) !== null && _q !== void 0 ? _q : " ",
                (_r = sheet === null || sheet === void 0 ? void 0 : sheet.savingAnnualCost) !== null && _r !== void 0 ? _r : " ",
                (_s = sheet === null || sheet === void 0 ? void 0 : sheet.savingAnnualCo2Emissions) !== null && _s !== void 0 ? _s : " ",
                (_t = sheet === null || sheet === void 0 ? void 0 : sheet.paybackPeriod) !== null && _t !== void 0 ? _t : " ",
                createdText, // 저장일시
            ],
        ], { origin: -1 });
        excelSheet["!cols"] = [
            { width: 8 },
            { width: 12 },
            { width: 12 },
            { width: 18 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 12 },
            { width: 14 },
            { width: 16 },
            { width: 16 },
            { width: 12 },
            { width: 16 },
            { width: 16 },
            { width: 16 },
            { width: 20 },
        ];
        return false;
    });
};
